import BaseCard from './BaseCard';
import { CardType } from './CardType';
import { PlinkoCardLayout } from 'Layouts/Card/PlinkoCard/PlinkoCardLayout';
import { getLayout, GLayout } from 'Utility/layout/LayoutHelper';
import { CARD_DRAGONBONES_PATH } from 'Constants/Dragonbones';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';

export default class PlinkoCard extends BaseCard {
    private layout: GLayout<PlinkoCardLayout>;

    public onCreate(params: any): void {
        params.cardFrontTexture = 'plinko_card';
        params.cardBackTexture = 'plinko_card';
        params.type = CardType.plinko;
        super.onCreate(params);

        this.layout = getLayout(PlinkoCardLayout);
        this.addChild(this.layout.root);

        this.container.interactiveChildren = false;
    }
    
    public static async preload(): Promise<void> {
        addDragonbonesResources('treasure_card', `${CARD_DRAGONBONES_PATH}/PlinkoCard/`);
    }

    public getLayout() {
        return this.layout;
    }
}
